// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistant_warnings_unresolvedapprover1 = /** @type {(inputs: { field: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No email address was found to send an approval request for the data point "${i?.field}".`)
};

const en_us2_assistant_warnings_unresolvedapprover1 = /** @type {(inputs: { field: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No email address was found to send an approval request for the data point "${i?.field}".`)
};

const de_de2_assistant_warnings_unresolvedapprover1 = /** @type {(inputs: { field: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es konnte keine E-Mail Adresse für eine Freigabeanfrage für den Datenpunkt "${i?.field}" ermittelt werden.`)
};

const en_assistant_warnings_unresolvedapprover1 = /** @type {(inputs: { field: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No email address was found to send an approval request for the data point "${i?.field}".`)
};

const de_assistant_warnings_unresolvedapprover1 = /** @type {(inputs: { field: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es konnte keine E-Mail Adresse für eine Freigabeanfrage für den Datenpunkt "${i?.field}" ermittelt werden.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ field: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistant_warnings_unresolvedapprover1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistant_warnings_unresolvedapprover1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistant_warnings_unresolvedapprover1", locale)
	if (locale === "en-GB") return en_gb2_assistant_warnings_unresolvedapprover1(inputs)
	if (locale === "en-US") return en_us2_assistant_warnings_unresolvedapprover1(inputs)
	if (locale === "de-DE") return de_de2_assistant_warnings_unresolvedapprover1(inputs)
	if (locale === "en") return en_assistant_warnings_unresolvedapprover1(inputs)
	return de_assistant_warnings_unresolvedapprover1(inputs)
};
export { assistant_warnings_unresolvedapprover1 as "assistant.warnings.unresolvedApprover" }